export default __webpack_public_path__ + "0ed8ee923d7089268d1a7056a9b5a8c1.woff2";